import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { CSSProperties } from "react";

export interface Styles {
  label: CSSProperties;
  whiteWrap: CSSProperties;
  error: CSSProperties;
  btnBlue:CSSProperties;
  btnRed:CSSProperties;
  btnCancel:CSSProperties;
  heading:CSSProperties;
  productImageWrap:CSSProperties;
  productImage:CSSProperties;
  sectionTopMargin?:CSSProperties;
  divCenter?:CSSProperties;
  btnLinkStyle?:CSSProperties;
}

const baseStyles: Styles = {
  
  label: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 28,
    color: "var(--text-color)",
    lineHeight: 1.2,
    display: "block",
  },
  
  error: {
    color: "#EA4335",
    fontSize: 16,
    fontFamily: "var(--primary-font-medium)",
  },
  whiteWrap: {
    paddingLeft: 50,
    paddingRight: 50,
    backgroundColor: "var(--white-color)",
    borderTopLeftRadius: 40,
    borderTopRightRadius: 40,
    paddingTop: 25,
    paddingBottom: 60,
  },
  btnBlue: {
    fontFamily:"var(--primary-font-semibold)",
    fontSize:20,
    color:"var(--white-color)",
    paddingTop:10,
    paddingBottom:10,
    marginTop:60,
    width:"31%",
    marginLeft:"3%",
    marginRight:"3%"
  },
  btnRed:{
    fontFamily:"var(--primary-font-semibold)",
    fontSize:20,
    color:"var(--text-color)",
    paddingTop:10,
    paddingBottom:10,
    marginTop:60,
    borderColor:"#EA4335",
    backgroundColor:"transparent",
    width:"31%",

  },
  btnCancel :{
     fontFamily:"var(--primary-font-semibold)",
    fontSize:20,
    color:"var(--text-color)",
    paddingTop:10,
    paddingBottom:10,
    marginTop:60,
    borderColor:"var(--text-color)",
    backgroundColor:"transparent",
    width:"31%",
  },
  
  heading:{
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 20,
    color: "var(--text-color)",
  },
  productImageWrap:{
    width:300,
    height:300,
    overflow:"hidden",
    paddingRight:30,
  },
  productImage:{
    width:"100%",
    height:"100%",
    objectFit:"contain"
  },
  sectionTopMargin:{
    marginTop: -60
  },
  divCenter: {
    display:"flex",
    justifyContent:"center",
  },
  btnLinkStyle: {
    textDecoration: "none",
    color: "white",
    width: "100%",
    display: "block",
  }
  
};

const mobileStyles: Partial<Styles> = {
  
  btnBlue: {
    fontFamily:"var(--primary-font-semibold)",
   fontSize:14,
   color:"var(--white-color)",
   paddingTop:10,
   paddingBottom:10,
   marginTop:20,
   width:"31%",
   marginLeft:"3%",
   marginRight:"3%"
 },
 btnRed:{
   fontFamily:"var(--primary-font-semibold)",
   fontSize:14,
   color:"var(--text-color)",
   paddingTop:10,
   paddingBottom:10,
   marginTop:20,
   borderColor:"#EA4335",
   backgroundColor:"transparent",
   width:"31%",

 },
 btnCancel :{
   fontFamily:"var(--primary-font-semibold)",
   fontSize:14,
   color:"var(--text-color)",
   paddingTop:10,
   paddingBottom:10,
   marginTop:20,
   borderColor:"var(--text-color)",
   backgroundColor:"transparent",
   width:"31%",
 },
  whiteWrap: {
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: "var(--white-color)",
    borderTopLeftRadius: 40,
    borderTopRightRadius: 40,
    paddingTop: 10,
    paddingBottom: 10,
  },
  sectionTopMargin:{
    marginTop: -60
  },
  divCenter: {
    display:"flex",
    justifyContent:"center",
  }
  
};
export const getStyles = (isMobile: boolean): Styles => {
  if (isMobile) {
    return {
      ...baseStyles,
      ...mobileStyles,
    };
  }
  return baseStyles;
};